import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GetAllPackegesAutocomplete} from "../Apis/Autocompleteapi";
import { GetAllPackegesByIdApi } from "../Apis/Package/Package";
import { GetAllPackagesApi } from "../Apis/Package/Package";


export const fetchPackegesAutocomplete = createAsyncThunk(
  "PackegessAutocomplete/fetchAutocomplete",
  async ({ page, limit }, { rejectWithValue }) => {
    try {
      const response = await GetAllPackegesAutocomplete(page, limit);
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return rejectWithValue({
        status: error.status || 500,
        message: error.message || "Failed to fetch users",
      });
    }
  }
);



export const fetchGetAllPackagesApi = createAsyncThunk(
  "fetAllPackagesApi/fetchGetAllPackagesApi",
  async ({ page = 1, limit = 10, filters = {} }, { rejectWithValue }) => {
    try {
      const response = await GetAllPackagesApi({ page, limit, filters });
      return {
        data: response.data,
        pagination: {
          page: response.page,
          total: response.total,
          totalPages: response.totalPages,
          limit: response.limit || limit,
        }
      };
    } catch (error) {
      return rejectWithValue({
        status: error.status || 500,
        message: error.message || "Failed to fetch reservations",
      });
    }
  }
);


export const fetchGetAllPackagesByIdApi = createAsyncThunk(
  'GetAllPackegesByIdApi/fetchGetAllPackegesByIdApi',
  async (id) => {
    const response = await GetAllPackegesByIdApi(id);
    return response;
  }
);


const initialState = {
  data: [],
  isLoading: false,
  error: null,
  status: null,
  pagination: {
    page: 1,
    pageSize: 10,
    total: 0,
    totalPages: 0
  }
};

const PackegessAutocompleteSlice = createSlice({
  name: "PackegesAutocomplete",
  initialState,
  reducers: {
    resetUsers: (state) => {
      state.data = [];
      state.error = null;
      state.status = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGetAllPackagesByIdApi.pending, (state) => {
      state.isLoading = true;
      state.data = [];
    })
      .addCase(fetchGetAllPackagesByIdApi.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload.data;
    })
      .addCase(fetchPackegesAutocomplete.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.status = null;
      })
      .addCase(fetchPackegesAutocomplete.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.status = action.payload.status
  
      })
      .addCase(fetchPackegesAutocomplete.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.message;
        state.status = action.payload.status;
        state.data = [];
      })
      .addCase(fetchGetAllPackagesApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchGetAllPackagesApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload.data;
        state.pagination = {
          page: action.payload.pagination.page,
          pageSize: action.payload.pagination.limit,
          total: action.payload.pagination.total,
          totalPages: action.payload.pagination.totalPages,
        };
      })
      .addCase(fetchGetAllPackagesApi.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload?.message;
        state.status = action.payload?.status;
      });
    
  },
});

export default PackegessAutocompleteSlice.reducer;  
